exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.msgbox{width:666px\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager/src/components/channel-test/index.vue"],"names":[],"mappings":";AACA,QAAQ,WAAW;CAClB","file":"index.vue","sourcesContent":["\n.msgbox{width:666px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f7394a4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/channel-test/index.vue
// module id = 9b7A
// module chunks = 8